<div
  class="munily-text-area-field"
  [ngClass]="hostClasses"
  [attr.aria-labelledby]="label ? labelId : null"
>
  <!-- <label *ngIf="label" [id]="labelId" class="munily-text-area-field__label">{{ label }}</label> -->

  <div class="munily-text-area-field__shell" (click)="onShellClick($event)">
    <quill-editor
      class="munily-text-area-field__editor"
      theme="snow"
      format="html"
      [formControl]="formControlForEditor"
      [modules]="quillModules"
      [formats]="quillFormats"
      [placeholder]="placeholder"
      [debounceTime]="editorDebounceMs"
      [styles]="quillEditorStyles"
      (onBlur)="onEditorBlur()"
    ></quill-editor>
  </div>

  <ng-container *ngIf="!showError() && (hint || hasCharacterCounter)">
    <div class="munily-text-area-field__sub">
      <p *ngIf="hint" class="munily-text-area-field__hint">{{ hint }}</p>
      <p *ngIf="hasCharacterCounter" class="munily-text-area-field__counter" aria-live="polite">
        {{ displayedCharacterCount }}<span *ngIf="maxCharacters != null"> / {{ maxCharacters }}</span>
      </p>
    </div>
  </ng-container>
  <p *ngIf="showError()" class="munily-text-area-field__error" role="alert">{{ resolvedErrorMessage }}</p>
</div>
